export const getUserAgent = (): string =>
  window.navigator ? navigator.userAgent.toLowerCase() : '';
